// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  calendarDateConverter_parseError: () =>
    'Încercaţi din nou folosind o dată completă precum aceasta: {dateExample}.',
  chart_labelGroup: () => 'Grup',
  chart_labelSeries: () => 'Serie',
  chart_labelValue: () => 'Valoare',
  checkboxSet_requiredMessageDetail: () => 'Obligatoriu',
  checkbox_requiredMessageDetail: () => 'Obligatoriu',
  close: () => 'Închidere',
  collection_noData: () => 'Nu există date de afişat.',
  collection_selectAllRows: () => 'Selectare toate rândurile',
  collection_selectRow: (p: { ROW_NAME: string }) => 'Selectaţi rândul ' + p['ROW_NAME'],
  collection_sortDisabled: () => 'Nu permite sortarea',
  collection_sortEnabled: () => 'Permite sortarea',
  confirmation: () => 'Confirmare',
  dataVisualization_labelAndValue: (p: { LABEL: string; VALUE: string }) =>
    p['LABEL'] + ': ' + p['VALUE'],
  dataVisualization_labelCountWithTotal: (p: { itemCount: string; totalCount: string }) =>
    p['itemCount'] + ' din ' + p['totalCount'],
  dataVisualization_noData: () => 'Nu există date de afişat',
  dataVisualization_stateSelected: () => 'Selectată',
  dataVisualization_stateUnselected: () => 'Neselectată',
  error: () => 'Eroare',
  expandableList_expandCollapseInstructionText: () =>
    'Utilizaţi tastele cu săgeţi pt. a extinde şi a restrânge',
  expandableList_groupCollapse: () => 'Restrâns',
  expandableList_groupExpand: () => 'Extins',
  filePicker_addFiles: () => 'Adăugare fişiere',
  filePicker_dropzonePrimaryText: () => 'Glisare şi plasare',
  filePicker_dropzoneSecondaryText: () => 'Selectaţi un fişier sau plasaţi unul aici',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Selectaţi fişiere sau plasaţi-le aici',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Nu puteţi încărca fişiere de tip: ' + p['fileTypes'],
  filePicker_singleFileUploadError: () => 'Încărcaţi doar câte un fişier',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Nu puteţi încărca fişiere de tip ' + p['fileType'],
  filePicker_unknownFileTypeUploadError: () => 'necunoscut',
  formControl_clear: () => 'Golire',
  formControl_day: () => 'Zi',
  formControl_helpAvailable: () => 'Asistenţă disponibilă',
  formControl_limitReached: (p: { CHARACTER_LIMIT: number }) =>
    'Aţi atins limita de ' +
    ((
      {
        one: '1 caracter',
        few: new Intl.NumberFormat('ro').format(p['CHARACTER_LIMIT']) + ' caractere'
      } as Partial<Record<Intl.LDMLPluralRule, string>>
    )[new Intl.PluralRules('ro').select(p['CHARACTER_LIMIT'])] ||
      new Intl.NumberFormat('ro').format(p['CHARACTER_LIMIT']) + ' caractere') +
    '.',
  formControl_loading: () => 'Se încarcă',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'S-a depăşit lungimea maximă, de ' + p['MAX_LENGTH'] + '.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    p['CHARACTER_COUNT'] + ' caractere rămase.',
  formControl_month: () => 'Lună',
  formControl_readOnly: () => 'Read-only',
  formControl_requiredMessageDetail: () => 'Introduceţi o valoare.',
  formControl_year: () => 'An',
  gantt_labelDate: () => 'Dată',
  gantt_labelEnd: () => 'Sfârşit',
  gantt_labelLabel: () => 'Etichetă',
  gantt_labelRow: () => 'Rând',
  gantt_labelStart: () => 'Început',
  indexer_disabledLabel: (p: { SECTION: string }) =>
    p['SECTION'] + '. Nu s-a găsit nicio secţiune care să corespundă.',
  indexer_keyboardInstructionText: () => 'Apăsaţi Enter pt. a selecta valoarea.',
  indexer_othersLabel: () => '#',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Între ' + p['FROM_SECTION'] + ' şi ' + p['TO_SECTION'] + '.',
  indexer_touchInstructionText: () =>
    'Atingeţi de două ori şi menţineţi apăsat pt. a intra în modul Gesturi, apoi trageţi în sus sau în jos pt. a ajuta valoarea.',
  info: () => 'Informaţii',
  inputDateMask_date_cleared: () => 'Data golirii',
  inputDateMask_dayPlaceholder: () => 'zz',
  inputDateMask_empty_segment: () => 'Necompletat',
  inputDateMask_monthPlaceholder: () => 'll',
  inputDateMask_yearPlaceholder: () => 'aaaa',
  inputNumber_converterParseError: () => 'Introduceţi un număr.',
  inputNumber_decrease: () => 'Scădere',
  inputNumber_increase: () => 'Creştere',
  inputPassword_hidden: () => 'Parolă ascunsă',
  inputPassword_hide: () => 'Ascundere parolă',
  inputPassword_show: () => 'Afişare parolă',
  list_suggestion: () => 'Sugestie',
  messageToast_allMessagesClosed: () => 'Toate mesajele de alertă sunt închise.',
  message_close: () => 'Închidere',
  message_confirmation: () => 'Reuşită',
  message_error: () => 'Eroare',
  message_info: () => 'Informaţii',
  message_navigationFromMessagesRegion: () =>
    'Se intră în regiunea Mesaje. Apăsaţi F6 pt. a naviga înapoi la elementul focalizat anterior.',
  message_navigationToMessagesRegion: () =>
    'În regiunea Mesaje există mesaje noi. Apăsaţi F6 pt. a naviga la regiunea cu cele mai recente mesaje.',
  message_warning: () => 'Avertisment',
  noData_message: () => 'Nu există niciun element de afişat',
  overflowItemLabel: () => 'Mai multe file',
  plural_separator: () => ', ',
  progressIndeterminate: () => 'În curs',
  radio_helpForRadio: () => 'Asistenţă pentru buton radio',
  radio_requiredMessageDetail: () => 'Selectaţi o valoare.',
  selectMultiple_apply: () => 'Aplicare',
  selectMultiple_back: () => 'Înapoi',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'Apăsaţi pe Backspace sau Delete pentru a elimina valoarea selectată.',
  selectMultiple_selectedValues: () => 'Valori selectate',
  selectMultiple_showSelectedValues: () => 'Afişaţi doar valorile selectate.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    p['VALUE_COUNT'] + ' valori selectate.',
  select_addToList: () => 'Adăugare în listă',
  select_addToListAvailable: () => 'Adăugare în lista disponibilă',
  select_moreSearchOptions: () => 'Mai multe opţiuni de căutare',
  select_moreSearchOptionsAvailable: () => 'Mai multe opţiuni de căutare disponibile',
  select_noMatchesFound: () => 'Nu s-a găsit niciun rezultat.',
  select_oneMatchFound: () => 'S-a găsit un rezultat.',
  select_requiredMessageDetail: () => 'Selectaţi o valoare.',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'S-au găsit ' + p['TOTAL_SIZE'] + ' rezultate',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'S-au găsit ' + p['TOTAL_SIZE'] + ' sau mai multe rezultate',
  selector_selected: () => 'Casetă de validare bifată',
  selector_unselected: () => 'Casetă de validare nebifată',
  tabBarNavigationList_removeCueText: () => 'Poate fi eliminat',
  timeComponent_tooltipZoomIn: () => 'Mărire',
  timeComponent_tooltipZoomOut: () => 'Micşorare',
  train_current: () => 'Curentă',
  train_message_type: () => 'Tip mesaj',
  train_not_visited: () => 'Nevizitată',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'Etapa ' + p['currentStep'] + ' din ' + p['numberOfSteps'],
  train_visited: () => 'Vizitată',
  userAssistance_learnMore: () => 'Mai multe informaţii',
  userAssistance_required: () => 'Obligatoriu',
  viz_drillable: () => 'Permite detalierea',
  warn: () => 'Avertisment'
};
export default bundle;
